





























import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import Context from "@/mixins/context";

// Enums
import { DataModules } from "@/store/modules/data";

// Types
import { IState } from "@/store";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "client-phones-list": () =>
      import("@/components/app/global/client/clientPhonesList.vue")
  },
  computed: {
    ...mapState({
      dataScope(state: IState, getters) {
        return getters[`data/${DataModules.CLIENTS_PHONES}/clientScope`](
          this.clientId
        );
      }
    })
  }
})
export default class ClientPhonesComp extends Mixins(Context) {
  // Props

  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ default: false })
  public isStaged!: boolean;

  @Prop({ default: null })
  public countryCode!: string;

  // Data

  public dataScope!: string;
  public canCreate = this.$userCan("create_client_phone");

  // Computed

  public get description() {
    if (this.isAdmin) return this.$t("_sentence.manage_phones_desc_for_staff");
    return this.$t("_sentence.manage_phones_desc_for_client", {
      brandName: this.$store.getters["brand/name"]
    });
  }

  // Methods

  public createPhone() {
    if (!this.canCreate) return;
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        width: 540,
        component: () =>
          import("@/components/app/global/client/addEditClientPhoneModal.vue"),
        props: {
          clientId: this.clientId,
          countryCode: this.countryCode
        }
      }
    });
  }
}
